<div class="prs-global-header" [class.active-subscription]="!!user?.active_subscription">
  <a
    class="skip-link"
    href="./#sphere-app-content"
    onclick="
      event.preventDefault();
      location.hash = 'sphere-app-content';
    "
    title="Skip to content"
    aria-label="Skip to content"
  >
    Skip to content
  </a>
  @if (uploadingFileCount && totalUploadPercentage) {
    <div class="file-upload-progress" [ngStyle]="{ width: 'calc(' + totalUploadPercentage + '% + 15px)' }"></div>
  }

  <div class="header-container">
    <div class="navbar" aria-label="website main menu">
      @if (!uploadingFileCount) {
        <a class="logo-container navbar-brand" [routerLink]="['/home']">
          <myp-svg id="fender-logo" class="svg-header-logo"></myp-svg>
        </a>
      }

      @if (uploadingFileCount) {
        <div class="logo-container">
          <div>
            <!-- <img [src]="appService.headerLogo" class="pointer text-logo" /> -->
            <span class="uploading-header-details">
              {{ "general.uploading" | translate }} {{ uploadingFileCount }} File{{ uploadingFileCount == 1 ? "" : "s" }}
              <span style="font-size: 12px; color: #eaeaea; display: block">
                {{ totalUploadPercentage }}% -
                <a (click)="downloadDetails()" class="c-lblue pointer">Details</a>
              </span>
            </span>
          </div>
        </div>
      }
      <nav>
        <ul class="navbar-nav options flex-row">
          <li class="nav-item mb-0" [routerLinkActive]="['active']" #productsRLA="routerLinkActive">
            <a
              [routerLink]="['/products']"
              (click)="trackPageEvent('products')"
              class="nav-option"
              attr.aria-label="{{ 'header.nav.products' | translate }}"
              [attr.aria-current]="productsRLA.isActive ? 'true' : null"
            >
              {{ "fui-header.my_gear" | translate }}
            </a>
          </li>
          <li class="nav-item mb-0" [routerLinkActive]="['active']" #learnRLA="routerLinkActive">
            <a
              [routerLink]="['/learn/']"
              (click)="trackPageEvent('learn')"
              class="nav-option"
              attr.aria-label="{{ 'header.nav.learn' | translate }}"
              [attr.aria-current]="learnRLA.isActive ? 'true' : null"
            >
              {{ "header.nav.learn" | translate }}
            </a>
          </li>
          <li class="nav-item mb-0" [routerLinkActive]="['active']" #supportRLA="routerLinkActive">
            <a
              [routerLink]="['/support']"
              (click)="trackPageEvent('support')"
              class="nav-option"
              attr.aria-label="{{ 'header.nav.support' | translate }}"
              [attr.aria-current]="supportRLA.isActive ? 'true' : null"
            >
              {{ "header.nav.support" | translate }}
            </a>
          </li>
          @if (user && (appService.app == "sphere" || productService.hasRecordingProducts || workspaceService.workspaces?.length || workspaceService.collabs?.length)) {
            <li class="nav-item mb-0" [routerLinkActive]="['active']" #workspacesRLA="routerLinkActive">
              <a
                [routerLink]="['/workspaces']"
                (click)="trackPageEvent('workspaces')"
                class="nav-option"
                attr.aria-label="{{ 'sphere.workspaces.workspaces' | translate }}"
                [attr.aria-current]="workspacesRLA.isActive ? 'true' : null"
              >
                {{ "sphere.workspaces.workspaces" | translate }}
              </a>
            </li>
          }
          @if (appService.app == "sphere") {
            <li class="nav-item mb-0" [routerLinkActive]="['active']" #exchangeRLA="routerLinkActive">
              <a
                [routerLink]="['/exchange']"
                (click)="trackPageEvent('exchange')"
                class="nav-option"
                attr.aria-label="{{ 'header.nav.exchange' | translate }}"
                [attr.aria-current]="exchangeRLA.isActive ? 'true' : null"
              >
                {{ "header.nav.exchange" | translate }}
              </a>
            </li>
          }
          @if (showCommunityLink) {
            <li class="nav-item mb-0" [routerLinkActive]="['active']" #communityRLA="routerLinkActive">
              @if (!user?.banned && communityService.profile?.status != "banned") {
                <a
                  [routerLink]="[environment.features.multiCommunity ? '/communities' : '/community']"
                  (click)="trackPageEvent('community')"
                  class="nav-option"
                  attr.aria-label="{{ 'com.community' | translate }}"
                  [attr.aria-current]="communityRLA.isActive ? 'true' : null"
                >
                  {{ "com.community" | translate }}
                </a>
              }
            </li>
          }

          @if (user) {
            <li class="nav-item mb-0" [routerLinkActive]="['active']">
              <a href="javascript:void(0)" (click)="appService.goToFenderShop()" class="nav-option" aria-label="Shop">Shop Fender.com</a>
            </li>
          } @else {
            <li class="nav-item mb-0" [routerLinkActive]="['active']">
              <a href="https://www.fender.com?utm_source=Fender&amp;utm_medium=my_fender" target="_blank" rel="noopener noreferrer" class="nav-option" aria-label="Shop">Shop Fender.com</a>
            </li>
          }
        </ul>
      </nav>
    </div>

    <div class="account">
      <div class="d-flex align-items-center justify-content-end">
        <div class="d-flex align-items-center pointer position-relative">
          @if (user) {
            <button
              role="“link”"
              class="btn bg-transparent header-btn"
              tabindex="“0”"
              (click)="profilePhotoClicked(communityService.connectionRequests?.length ? 'connections' : 'about')"
              aria-label="visit profile"
              (keyup.enter)="profilePhotoClicked(communityService.connectionRequests?.length ? 'connections' : 'about')"
            >
              <img alt="PreSonus - User Profile" class="profile-photo" [src]="userService.profilePicture" aria-label="user profile" />
              @if (communityService.connectionRequests?.length) {
                <span
                  [ngbTooltip]="'com.connection_requests_count' | translate: { count: communityService.connectionRequests.length, plural: communityService.connectionRequests.length > 1 ? 's' : '' }"
                  attr.aria-label="{{
                    'com.connection_requests_count' | translate: { count: communityService.connectionRequests.length, plural: communityService.connectionRequests.length > 1 ? 's' : '' }
                  }}"
                  class="unread-messages-badge"
                >
                  {{ communityService.connectionRequests.length }}
                </span>
              }
            </button>
            @if (showAudioPlayerIcon) {
              <div class="header-audio-player-icon" [class.playing]="audioPlayer.isPlaying" (click)="showAudioPlayer = !showAudioPlayer">
                <myp-svg id="record" width="24" height="24"></myp-svg>
              </div>
            }
            <button
              type="button"
              id="header-menu-button"
              class="btn bg-transparent header-btn"
              (click)="hamburgerClick()"
              (keydown.space)="$event.preventDefault(); hamburgerClick()"
              [attr.aria-expanded]="appService.showNavOverlay"
              aria-controls="cloud-nav-overlay"
              [attr.aria-label]="'general.menu' | translate"
            >
              <fa-icon class="c-white circle-icon-btn hamburger-menu-icon" data-cy="header-options" [icon]="appService.showNavOverlay ? 'times' : 'bars'" aria-hidden="true"></fa-icon>
              <span class="sr-only">{{ "general.menu" | translate }}</span>
              @if (userService.needsToLinkFenderAccount) {
                <span class="unread-messages-badge">!!</span>
              }
            </button>
            <a class="btn bg-transparent header-btn" [routerLink]="['/messages']" aria-label="messages">
              <fa-icon class="c-white circle-icon-btn" icon="envelope" aria-hidden="true"></fa-icon>
              <span class="sr-only">messages</span>
              @if (communityService.unreadCounts.total) {
                <span class="unread-messages-badge">{{ communityService.unreadCounts.total }}</span>
              }
            </a>
            @if (communityService.notificationCount) {
              <button
                class="btn bg-transparent header-btn"
                aria-label="notifications"
                (click)="showNotifications = !showNotifications"
                [attr.aria-expanded]="showNotifications"
                aria-controls="notifications-overlay"
              >
                <fa-icon class="c-white circle-icon-btn" icon="bell" aria-hidden="true"></fa-icon>
                <span class="sr-only">notifications</span>
                @if (communityService.unreadNotificationCount) {
                  <span class="unread-messages-badge">{{ communityService.unreadNotificationCount }}</span>
                }
              </button>
            }
          } @else {
            <button type="button" class="btn bg-transparent header-btn" (click)="signIn()" (keyup.enter)="signIn()" aria-label="Sign in or create account">
              <fa-icon class="c-white circle-icon-btn" icon="user" aria-hidden="true"></fa-icon>
              <span class="sr-only">Sign in or create account</span>
            </button>
            @if (showAudioPlayerIcon) {
              <div class="header-audio-player-icon" [class.playing]="audioPlayer.isPlaying" (click)="showAudioPlayer = !showAudioPlayer">
                <myp-svg id="record" width="24" height="24"></myp-svg>
              </div>
            }
            <button
              type="button"
              id="header-menu-button"
              class="btn bg-transparent header-btn"
              (click)="hamburgerClick()"
              (keydown.space)="$event.preventDefault(); hamburgerClick()"
              [attr.aria-expanded]="appService.showNavOverlay"
              aria-controls="cloud-nav-overlay"
              [attr.aria-label]="'general.menu' | translate"
            >
              <fa-icon class="c-white circle-icon-btn hamburger-menu-icon" data-cy="header-options" [icon]="appService.showNavOverlay ? 'times' : 'bars'" aria-hidden="true"></fa-icon>
              <span class="sr-only">{{ "general.menu" | translate }}</span>
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
@if (showNotifications && user) {
  <myp-notifications-overlay id="notifications-overlay" (closed)="showNotifications = false"></myp-notifications-overlay>
}
<div class="audio-player-container">
  <myp-audio-player #audioPlayer [shown]="showAudioPlayer"></myp-audio-player>
</div>
